// src/pages/Music.tsx
import React, { useEffect, useState } from 'react';
import './Music.css';
import { getMusics } from '../queries/getMusics';
// 1. Rename the imported type 'Music' to 'MusicType' using 'as'
import { Music as MusicType } from '../types'; 

// 2. The Component keeps the name 'Music'
const Music: React.FC = () => {
  // 3. Use the renamed type 'MusicType' for the state
  const [favoriteAlbums, setFavoriteAlbums] = useState<MusicType[]>([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMusic() {
      try {
        const data = await getMusics();
        setFavoriteAlbums(data);
      } catch (error) {
        console.error("Error fetching music data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchMusic();
  }, []);

  const handleAlbumClick = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  if (loading) return <div className="music-page">Loading tunes...</div>;
  if (favoriteAlbums.length === 0) return <div className="music-page">No favorite tracks found.</div>;

  return (
    <div className="music-page">
      <div className="quote">
        <p>“Music is the closest thing we have to magic.” 🎶</p>
      </div>

      <div className="albums-section">
        <h3>Favorite Tracks</h3>
        <div className="albums">
          {favoriteAlbums.map((album, index) => (
            <div 
              key={index} 
              className="album-card" 
              style={{ animationDelay: `${index * 0.3}s` }}
              onClick={() => handleAlbumClick(album.youtubeUrl)}
            >
              <img 
                src={album.coverImage.url}
                alt={album.title} 
                className="album-image" 
                loading="lazy"
              />
              <div className="album-details">
                <h4>{album.title}</h4>
                <p>by {album.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Music;